
import {serializeError, ErrorObject } from 'serialize-error';

export class EpDevPError extends Error {
  private internalStack: Array<string>;
  public internalLogName: string;

  private createArrayFromStack(stack: any): Array<string> {
    if(stack) return stack.split('\n');
    return [];
  }

  constructor(internalLogName: string, internalMessage: string) {
    super(internalMessage?internalMessage:internalLogName);
    this.name = this.constructor.name;
    this.internalLogName = internalLogName;
    this.internalStack = this.createArrayFromStack(this.stack);
  }

  public toJSON(): ErrorObject {
    const funcName = 'toJSON';
    const logName = `${EpDevPError.name}.${funcName}()`;
    try {
      return serializeError(this);
    } catch (e: any) {
      return {
        logName: logName,
        error: `serializeError(this): ${e.name}: ${e.message}`,
        name: e.name,
        message: e.message,
        this: {
          internalLogName: this.internalLogName,
          internalStack: this.internalStack,
          name: this.name,
          message: this.message,  
        }
      }
    }
  }
}

